class DDDCatalog extends HTMLElement {
  connectedCallback() {
    this.media = window.matchMedia('(min-width: 750px)');
    this.browse = this.querySelector('.ddd-catalog__browse');
    this.adapt = () => { if (this.browse) this.browse.open = this.media.matches; };
    this.adapt();
    this.media.addEventListener('change', this.adapt);
  }
  disconnectedCallback() { this.media?.removeEventListener('change', this.adapt); }
}
if (!customElements.get('ddd-catalog')) customElements.define('ddd-catalog', DDDCatalog);
